// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".version-alert{animation:versionAlert 2s ease-in-out infinite}@keyframes versionAlert{0%{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}50%{box-shadow:0 2px 18px 6px rgba(0,0,0,.3)}to{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
